import { useFlags } from "launchdarkly-react-client-sdk";

import { useAppSelector } from "app/hooks";
import { selectFeatures } from "features/auth/auth-slice";
import { canManageScribeTemplatesFor } from "features/medical-scribe/scribe-template-access.util";
import useUserRoles from "hooks/use-user-roles.hook";

/** Whether to offer this user the way into Scribe Settings: the button, and the guide's link. */
export default function useCanManageScribeTemplates(): boolean {
  const flags = useFlags();
  const roles = useUserRoles();
  const features = useAppSelector(selectFeatures);
  return canManageScribeTemplatesFor(flags, roles, features);
}
